






























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { UserModule } from '@/app/store/modules/user'
import { MasterModule } from '@/app/store/modules/master'
import { User } from '../../../../../domain/entities/User'

@Component
export default class extends Vue {
  @Prop({}) public dataTable
  @Prop({}) public isDisabled
  @Prop({}) public storageType: string | undefined

  public byActiveStatus: string = ''
  public dealerarea: string = ''
  public team: string = ''

  public byPosition3: any = []
  public byPosition2: string = ''
  public byPosition: string = ''
  public byCity: string = ''
  public byLoginStatus: string = ''
  public statusRegistration: string = ''

  @Watch('byPosition3')
  public onPosition3Changed(value: string, oldValue: string) {
    this.byPosition = this.byPosition3.toString()
  }

  public cities: any = []
  public positions: any = []
  public get cityData() {
    this.cities = MasterModule.MasterData.data
    return MasterModule.MasterData
  }
  public get positionData() {
    this.positions = MasterModule.PositionData.data
    return MasterModule.PositionData
  }

  public dealergroup: string = ''
  public dealergroupId: string = ''
  public byDealerGroup(text) {
    const find = this.dealerGroupOptions.find(
      (e) => e.name === text.split('/')[0] || ''
    )
    const index = this.dealerGroupOptions.indexOf(find)
    if (text.length >= 3 && index === -1) {
      MasterModule.paginationParam.search = text
      MasterModule.getDealerGroup()
    }
    const a = text.split('/')[1]
    if (this.dealerGroupOptions.length > 0 && text.length >= 3) {
      this.dealergroupId =
        this.dealerGroupOptions.find((e) => e.id === Number(a)).id || ''
    }
  }
  public dealerGroupOptions: any = []
  public get groupCode() {
    this.dealerGroupOptions = MasterModule.DealerGroupData.data
    return MasterModule.DealerGroupData
  }

  public dealercode: string = ''
  public dealercodeId: string = ''
  public byDealerCode(text) {
    const find = this.dealerCodeOptions.find(
      (e) => e.name === text.split('/')[0] || ''
    )
    const index = this.dealerCodeOptions.indexOf(find)
    if (text.length >= 3 && index === -1) {
      MasterModule.paginationParam.search = text
      MasterModule.getDealerName()
    }
    const a = text.split('/')[1]
    if (this.dealerCodeOptions.length > 0 && text.length >= 3) {
      this.dealercodeId =
        this.dealerCodeOptions.find((e) => e.id === Number(a)).id || ''
    }
  }
  public dealerCodeOptions: any = []
  public get dealerCode() {
    this.dealerCodeOptions = MasterModule.DealerNameData.data
    return MasterModule.DealerNameData
  }

  // FIlter By Dealer Name
  public dealername: string = ''
  public dealerNameId: string = ''
  public byDealerName(text) {
    const find = this.dealerNameOptions.find(
      (e) => e.name === text.split('/')[0] || ''
    )
    const index = this.dealerNameOptions.indexOf(find)
    //  console.log(index)
    if (text.length >= 3 && index === -1) {
      MasterModule.paginationParam.search = text
      MasterModule.getDealerName()
    }
    const a = text.split('/')[1]
    if (this.dealerNameOptions.length > 0 && text.length >= 3) {
      this.dealerNameId =
        this.dealerNameOptions.find((e) => e.id === Number(a)).id || ''
    }
  }
  public dealerNameOptions: any = []
  public get dealerNameCode() {
    this.dealerNameOptions = MasterModule.DealerNameData.data
    return MasterModule.DealerNameData
  }

  public hasFilter = false
  public clearFilter() {
    this.hasFilter = false
    UserModule.paginationParam.paging.page = 1
    UserModule.paginationParam.paging.limit = 10
    UserModule.paginationParam.sort.column = 'id'
    UserModule.paginationParam.sort.type = 'asc'
    UserModule.paginationParam.filter.position = UserModule.paginationParam.filter.dealername =
      ''
    UserModule.paginationParam.filter.dealerCity = ''
    UserModule.paginationParam.filter.dealerBranch = ''
    UserModule.paginationParam.filter.active = ''
    UserModule.paginationParam.filter.dealerarea = ''
    UserModule.paginationParam.filter.team = ''
    UserModule.paginationParam.filter.dealercode = ''
    UserModule.paginationParam.filter.dealergroup = ''
    UserModule.paginationParam.filter.statusRegistration = ''
    UserModule.paginationParamsExport.paging.page = 1
    UserModule.paginationParamsExport.paging.limit = 10
    UserModule.paginationParamsExport.sort.column = 'id'
    UserModule.paginationParamsExport.sort.type = 'asc'
    UserModule.paginationParamsExport.filter.position = ''
    UserModule.paginationParamsExport.filter.dealername = ''
    UserModule.paginationParamsExport.filter.dealerCity = ''
    UserModule.paginationParamsExport.filter.dealerBranch = ''
    UserModule.paginationParamsExport.filter.active = ''
    UserModule.paginationParamsExport.filter.dealerarea = ''
    UserModule.paginationParamsExport.filter.team = ''
    UserModule.paginationParamsExport.filter.dealercode = ''
    UserModule.paginationParamsExport.filter.dealergroup = ''
    UserModule.paginationParamsExport.filter.statusRegistration = ''
    this.storageType === 'sfid'
      ? UserModule.getUserDataSFID()
      : UserModule.getUserDataDNET()
    UserModule.getExportData()
    this.byPosition3 = []
    this.byPosition = ''
    this.byActiveStatus = ''
    this.dealername = ''
    this.byCity = ''
    this.dealerarea = ''
    this.team = ''
    this.dealercode = ''
    this.dealergroup = ''
    this.statusRegistration = ''
  }

  public get disableFilter(): boolean {
    if (
      this.byPosition3.length !== 0 ||
      this.byActiveStatus ||
      this.dealername ||
      this.dealerarea ||
      this.team ||
      this.dealercode ||
      this.dealergroup ||
      this.statusRegistration ||
      this.byCity !== ''
    ) {
      return false
    } else {
      return true
    }
  }

  public optionByActiveStatus: any = [
    { value: '', text: 'Employee Status' },
    { value: 'true', text: 'Active' },
    { value: 'false', text: 'Non Active' },
  ]
  public items: any = [
    'Salesman',
    'Salesman Counter',
    'Branch Manager',
    'Sales Manager',
    'Supervisor',
  ]

  public teamOptions: any = [
    { value: '', text: 'Team Category' },
    { value: 'PC', text: 'PC' },
    { value: 'LCV', text: 'LCV' },
  ]

  public statusRegistrationOptions: any = [
    { value: '', text: 'Registration Status' },
    { value: 'true', text: 'Registered' },
    { value: 'false', text: 'Unregistered' },
  ]

  public onRemovePosition(data) {
    const index = this.byPosition3.indexOf(data)
    this.byPosition3.splice(index, 1)
    this.byPosition = this.byPosition3.join(',').replace(/\s/g, '')
  }

  public onOptionClickPosition(data) {
    this.byPosition3.push(data)
    this.byPosition = this.byPosition3.join(',').replace(/\s/g, '')
    // console.log('By position')
    // console.log(this.byPosition)
    this.byPosition2 = ''
  }

  public getExportDataParams() {
    UserModule.paginationParamsExport.paging.page = 1
    UserModule.paginationParamsExport.paging.limit = 10
    UserModule.paginationParamsExport.sort.column = 'id'
    UserModule.paginationParamsExport.sort.type = 'asc'
    UserModule.paginationParamsExport.filter.position = this.byPosition3
    UserModule.paginationParamsExport.filter.dealerCity =
      this.byCity === ''
        ? ''
        : this.cities.find((item) => item.name === this.byCity).id
    UserModule.paginationParamsExport.filter.dealername = this.dealername.split(
      '/'
    )[1]
    UserModule.paginationParamsExport.filter.dealerarea = this.dealerarea
    UserModule.paginationParamsExport.filter.active = this.byActiveStatus
    UserModule.paginationParamsExport.filter.dealerarea = this.dealerarea
    UserModule.paginationParamsExport.filter.team = this.team
    UserModule.paginationParamsExport.filter.dealercode = this.dealercode
    UserModule.paginationParamsExport.filter.dealergroup = this.dealergroup.split(
      '/'
    )[0]
    UserModule.paginationParamsExport.filter.statusRegistration = this.statusRegistration
    UserModule.getExportData()
  }

  public filterUserData() {
    this.hasFilter = true
    UserModule.paginationParam.paging.page = 1
    UserModule.paginationParam.paging.limit = 10
    UserModule.paginationParam.sort.column = 'id'
    UserModule.paginationParam.sort.type = 'asc'
    UserModule.paginationParam.filter.position = this.byPosition3
    UserModule.paginationParam.filter.dealername = this.dealername.split('/')[1]
    UserModule.paginationParam.filter.dealerCity =
      this.byCity === ''
        ? ''
        : this.cities.find((item) => item.name === this.byCity).id
    UserModule.paginationParam.filter.active = this.byActiveStatus
    UserModule.paginationParam.filter.dealerarea = this.dealerarea
    UserModule.paginationParam.filter.team = this.team
    UserModule.paginationParam.filter.dealercode = this.dealercode
    UserModule.paginationParam.filter.dealergroup = this.dealergroup.split(
      '/'
    )[0]
    UserModule.paginationParam.filter.statusRegistration = this.statusRegistration
    this.storageType === 'sfid'
      ? UserModule.getUserDataSFID()
      : UserModule.getUserDataDNET()
  }

  public onClickFilter() {
    this.getExportDataParams()
    this.filterUserData()
  }
}
